module.exports = __webpack_public_path__ + "static/media/enelLogoGrey.312d07e1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/enelLogoGrey.png
// module id = 1755
// module chunks = 0